/**
 * Serviço de Máquinas de Cartão
 * Cadastro das maquininhas da clínica e taxas por parcela
 */

import api from './api';

const maquinaCartaoService = {
  listar: async () => {
    return api.get('/maquinas-cartao');
  },

  criar: async (nome) => {
    return api.post('/maquinas-cartao', { nome });
  },

  atualizar: async (id, dados) => {
    return api.put(`/maquinas-cartao/${id}`, dados);
  },

  remover: async (id) => {
    return api.delete(`/maquinas-cartao/${id}`);
  },

  salvarTaxas: async (id, taxas) => {
    return api.put(`/maquinas-cartao/${id}/taxas`, { taxas });
  },
};

export default maquinaCartaoService;
